import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { mainHeadingTypographyStyles } from '../../../shared/ui';

import { AuthTopBar } from './auth-top-bar';

const LoginHeaderContainer = styled.div.attrs({
  'data-ui': 'auth-login-header',
})`
  display: grid;
  gap: ${({ theme }) => theme.scale.px(48)};
`;

const LoginHeading = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.scale.px(7)};
`;

const LoginTitle = styled.h1`
  ${mainHeadingTypographyStyles};
  width: ${({ theme }) => theme.scale.px(226)};
`;

const LoginSubtitle = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.scale.px(12)};
  font-weight: 500;
`;

export function LoginHeader() {
  const { t } = useTranslation();

  return (
    <LoginHeaderContainer>
      <AuthTopBar />

      <LoginHeading>
        <LoginTitle>{t('login.title')}</LoginTitle>
        <LoginSubtitle>{t('login.subtitle')}</LoginSubtitle>
      </LoginHeading>
    </LoginHeaderContainer>
  );
}
